var map = {
	"./dragontiger_en.png": "8eV3",
	"./dragontiger_th.png": "lwo7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B0L8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/dragontiger_.*\.png$
// module id = B0L8
// module chunks = 1